import { render, staticRenderFns } from "./InvoiceDetails.vue?vue&type=template&id=65b5326d&scoped=true&"
import script from "./InvoiceDetails.vue?vue&type=script&lang=js&"
export * from "./InvoiceDetails.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceDetails.vue?vue&type=style&index=0&id=65b5326d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b5326d",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VMenu,VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65b5326d')) {
      api.createRecord('65b5326d', component.options)
    } else {
      api.reload('65b5326d', component.options)
    }
    module.hot.accept("./InvoiceDetails.vue?vue&type=template&id=65b5326d&scoped=true&", function () {
      api.rerender('65b5326d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/invoices/InvoiceDetails.vue"
export default component.exports